// 首页
import request from '@/utils/request'

// 添加绑定设备
export function add(params) { // 选择设备类型下拉框
  return request({
    url: 'v3/manager/deviceBindSystem/add',
    method: 'post',
    data: params
  })
}
// 添加设备--序列号下拉框
export function querySearchSn(params) {
  return request({
    url: 'v3/manager/device/querySearchBaseInfoSn?sn=' + params,
    method: 'post'
  })
}
//  添加设备--设备版本号
export function getLastMessageBootReq(param) {
  return request({
    url: '/v3/manager/configData/getLastMessageBootReq?mcuId=' + param.mcuId,
    method: 'get'
  })
}
// 添加设备--电池型号下拉框
export function cascader() {
  return request({
    url: 'v3/manager/deviceBattery/cascader',
    method: 'post'
  })
}
//  添加设备--下拉框客户名称
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
// 添加设备--公司信息下拉框
export function getList(params) {
  return request({
    url: '/v3/user/company/list',
    method: 'post',
    data: params
  })
}
// 所有设备
export function pageList(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/pageList',
    method: 'post',
    data: params
  })
}
// 修改绑定设备
export function update(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/update',
    method: 'post',
    data: params
  })
}
// 删除绑定设备
export function deleteSystem(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/delete',
    method: 'post',
    data: params
  })
}
// 添加设备--通过batteryId获取电池信息
export function deviceBattery(params) {
  return request({
    url: 'v3/manager/deviceBattery/get?id=' + params.id,
    method: 'get'
  })
}
// 获取配置--dcdc
export function getDMTCfg(params) {
  return request({
    url: '/v3/device/mqtt/getDMTCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--bidirectional（双向逆变器）
export function getIvtCfg(params) {
  return request({
    url: '/v3/device/mqtt/getIvtCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--inverterDetailNew（单向逆变器）
export function getCBBCfg(params) {
  return request({
    url: '/v3/device/mqtt/getCBBCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--acChargeDetail（AC充电器）
export function getTCCfg(params) {
  return request({
    url: '/v3/device/mqtt/getTCCfg',
    method: 'get',
    params: params
  })
}
// 详情页
// 根据mcuId获取详情  （单个详情， 下面有关联设备信息 ）
export function detail(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/detail?mcuId=' + params.mcuId + '&stime=' + params.stime,
    method: 'get'
  })
}
// 实时数据
export function GetRealTimeData(params) {
  return request({
    url: '/v3/device/mqtt/GetRealTimeData',
    method: 'post',
    data: params
  })
}
// 新增绑定Kisae
export function addDeviceBindSystemBase(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/addDeviceBindSystemBase',
    method: 'post',
    data: params
  })
}
// 编辑绑定Kisae
export function updateDeviceBindSystemBase(params) {
  return request({
    url: '/v3/manager/deviceBindSystem/updateDeviceBindSystemBase',
    method: 'post',
    data: params
  })
}
// ////////////

// 所有数据
export function findDeviceList(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceList',
      method: 'post',
      data: params
    })
  }
}
export function sysDictInfo(params) { // 选择设备类型下拉框
  return request({
    url: 'v3/manager/sysDict/sysDictInfo',
    method: 'get',
    params: params
  })
}
export function deviceOnlineStatistic(params) { // 设备联网率
  return request({
    url: 'v3/report/deviceOnlineStatistic',
    method: 'post',
    data: params
  })
}
// 添加设备--品牌型号下拉框
export function deviceMechcascader() {
  return request({
    url: 'v3/manager/deviceMech/cascader',
    method: 'get'
  })
}
export function updatePushSwitch(mcuId, on) { // 添加设备--通知推送
  var param = ''
  if (typeof (on) === 'undefined') {
    param = ''
  } else {
    param = '&on=' + on
  }
  return request({
    url: 'v2/deviceBindUser/updatePushSwitch?mcuId=' + mcuId + param,
    method: 'get'
  })
}
export function addDeviceBind(params) { // 添加设备--提交
  return request({
    url: 'v3/manager/addDeviceBind',
    method: 'post',
    data: params
  })
}
// 编辑设备信息弹窗--提交
export function updateDeviceBind(params) {
  return request({
    url: '/v3/manager/updateDeviceBind',
    method: 'post',
    data: params
  })
}
// 编辑设备重置时间弹窗--提交
export function addDeviceReset(params) {
  return request({
    url: '/v3/manager/addDeviceReset',
    method: 'post',
    data: params
  })
}// 编辑设备信息弹窗--恢复出厂设置
export function addDeviceAllReset(params) {
  return request({
    url: '/v3/manager/addDeviceAllReset',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getDeviceInfoByMcuId(params) {
  return request({
    url: '/v3/report/getDeviceInfoByMcuId',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getRealTimeInfo1(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo1/' + param.sn,
    method: 'get'
  })
}
// 设备信息
export function getRealTimeInfo2(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo2/' + param.sn,
    method: 'get'
    // params: param
  })
}
// 获取警告信息
export function warningListByMcuId(params) {
  return request({
    url: '/v3/report/warningListByMcuId',
    method: 'post',
    data: params
  })
}
// 获取设备最后的位置
export function getGNSSLastByMcuID(params) {
  return request({
    url: '/v3/location/getGNSSLastByMcuID',
    method: 'post',
    data: params
  })
}
export function getGnssConfig(params) {
  return request({
    url: '/v3/location/getGnssConfig',
    method: 'post',
    data: params

  })
}
export function updateGnssConfig(params) {
  return request({
    url: '/v3/location/updateGnssConfig',
    method: 'post',
    // headers: { 'token': 'nmamtf' },
    data: params

  })
}
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 获取最后一条YhubConfig
export function getLastYhubConfig(params) {
  return request({
    url: '/v3/manager/yhubConfig/getLastYhubConfig',
    method: 'post',
    data: params
  })
}
// 获取锂电池信息
export function getLastOneMsgBMSData(params) {
  return request({
    url: '/v3/canbus/getLastOneMsgBMSData',
    method: 'post',
    data: params
  })
}
export function listMsgBMSData(params) {
  return request({
    url: '/v3/canbus/listMsgBMSData',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 设备总数量、当前异常数、设备类型占比、当前异常--柱状图
export function findCompanyDeviceStatistic(params) {
  return request({
    url: '/v3/report/findCompanyDeviceStatistic',
    method: 'post',
    data: params
  })
}
// 锂电池详情页--allDeviceLithiumDetail
export function getLastBMSRecor(param) {
  return request({
    url: '/v3/canbus/bmsRecord/getLastBMSRecor?mcuId=' + param.mcuId,
    method: 'get'
  })
}
// 锂电池走势页--lithiumChartPage
export function listBMSRecor(params) {
  return request({
    url: '/v3/canbus/bmsRecord/listBMSRecor',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
